"use client";
import {
  DisclosureContextProvider
} from "../__chunks/P3UIANB7.js";
import "../__chunks/LFJDOMBA.js";
import {
  useDisclosureStore
} from "../__chunks/4ORPOXHX.js";
import "../__chunks/2ID5JPOO.js";
import "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import "../__chunks/2SMRF6AD.js";

// src/disclosure/disclosure-provider.tsx
import { jsx } from "react/jsx-runtime";
function DisclosureProvider(props = {}) {
  const store = useDisclosureStore(props);
  return /* @__PURE__ */ jsx(DisclosureContextProvider, { value: store, children: props.children });
}
export {
  DisclosureProvider
};
